/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { confirmedBookingsIndex } from '../../axios/confirmedBookingsIndex'
import type { ConfirmedBookingsIndexError, ConfirmedBookingsIndexResponse } from '../../types/ConfirmedBookingsIndex'

export const confirmedBookingsIndexQueryKey = () => [{ url: '/interview-scheduling/bookings' }] as const

export type ConfirmedBookingsIndexQueryKey = ReturnType<typeof confirmedBookingsIndexQueryKey>

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/ConfirmedBookingsController.php ConfirmedBookingsController::index */
export function confirmedBookingsIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		ConfirmedBookingsIndexResponse,
		AxiosError<ConfirmedBookingsIndexError>,
		ConfirmedBookingsIndexResponse,
		ConfirmedBookingsIndexQueryKey
	>({
		queryKey: confirmedBookingsIndexQueryKey(),
		queryFn: ({ signal }) => confirmedBookingsIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/ConfirmedBookingsController.php ConfirmedBookingsController::index */
export function useConfirmedBookingsIndex<TSelectData = ConfirmedBookingsIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					ConfirmedBookingsIndexResponse,
					AxiosError<ConfirmedBookingsIndexError>,
					TSelectData,
					ConfirmedBookingsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<ConfirmedBookingsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...confirmedBookingsIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/ConfirmedBookingsController.php ConfirmedBookingsController::index */
export function useConfirmedBookingsIndexSuspense<TSelectData = ConfirmedBookingsIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					ConfirmedBookingsIndexResponse,
					AxiosError<ConfirmedBookingsIndexError>,
					TSelectData,
					ConfirmedBookingsIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<ConfirmedBookingsIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...confirmedBookingsIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
